<!-- <app-question-type-match-order></app-question-type-match-order> -->
<div *ngIf="!isListMode && !display">
  <div class="matchOrderBtn">
    <button mat-flat-button color="warn" class="btn-warn" (click)="back()">
      <span>{{'questions.typeOfQuestions.DragAndDrop.btnBack' | translate}}</span>
    </button>
    <button mat-flat-button color="" [disabled]="!matchOrderForm.valid" class="btn-primary" (click)="saveMatchOrderQuestion()" >
      <span>{{'questions.typeOfQuestions.DragAndDrop.btnSave' | translate}}</span>
    </button>
  </div>

  <form [formGroup]="matchOrderForm">
    <ng-container>
      <div class="filter-section">
        <div class="body-section title">
          <mat-icon>library_add</mat-icon>
          <span>{{'questions.typeOfQuestions.DragAndDrop.title' | translate}}</span>
        </div>
        <div class="body-section-2" [formGroupName]="reuseProp.questiondescription">
          <label class="que-label">{{'questions.typeOfQuestions.DragAndDrop.labelQuest' | translate}}</label>
          <ckeditor #myEditor1 [formControlName]="reuseProp.description" [editor]="Editor" (click)="onClick(true)" (ready)="onReady($event)"></ckeditor>
          <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
          <!-- <ckeditor data="Enter here..." [formControlName]="reuseProp.description" [config]="ckeditorConfig" [ngClass]="{'ckeditor-loading': isCkeditorLoading}" (ready)="onCkeditorReady()"></ckeditor> -->
        </div>
      </div>
      <div *ngIf="validateQuestion" class="text-msg">
        <span>{{'questions.typeOfQuestions.DragAndDrop.errorQuestion' | translate}}</span>
      </div>
    </ng-container>

    <div>
      <div class="filter-section">
        <div class="body-section title"> <span>{{'questions.typeOfQuestions.DragAndDrop.labelPrompt' | translate}}</span> </div>
      </div>
      <div class="body-section-2">
        <ckeditor #myEditor2 [formControlName]="reuseProp.tempPromt" [editor]="Editor" (ready)="onReadyPrompt($event)"></ckeditor>
        <div *ngIf="errorMessagePrompt" class="alert alert-danger">{{ errorMessagePrompt }}</div>
        <!-- <ckeditor [config]="ckeditorConfig" [formControlName]="reuseProp.tempPromt"></ckeditor> -->
      </div>
      <div class="btn-container">
        <button mat-flat-button color="" class="btn-warn" (click)='validateAndAddPromt()'>
          {{'questions.typeOfQuestions.DragAndDrop.btnPrompt' | translate}}
        </button>
      </div>
      <div class="filter-section">
        <div class="body-section title">
          <span>{{'questions.typeOfQuestions.DragAndDrop.labelPromptText' | translate}}</span>
        </div>
      </div>
      <div class="body-section-2">
        <div class="score-wrapper">
          <div class="add-option">
            <div class="input-class-container">
              <div class="metrix-list-wrapper alphabetic-list col-12">
                <table class="container col-md-11
                  table-body" *ngFor="let o of
                  matchOrderForm.controls[reuseProp.promptRequests].value;
                  let i= index">
                  <tbody>
                    <tr class="border-row">
                      <td scope="row" class="promt-item"> <ng-component
                          [innerHTML]="o?.promptdescription.description | sanitizeHtml"></ng-component>
                        <div class="drag-box" *cdkDragPreview>
                          <span [innerHtml]="o?.answerDescription?.description"></span>
                        </div>
                      </td>
                      <td class="promt-btn">
                        <button mat-icon-button matTooltip="{{'questions.typeOfQuestions.DragAndDrop.addOptions.toolTip.edit' | translate}}"
                        (click)="openDialog(o,true)">
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button matTooltip="{{'questions.typeOfQuestions.DragAndDrop.addOptions.toolTip.delete' | translate}}"
                        [ngClass]="{'disableIcon': roleSer.accessData? !roleSer.accessData.deleteAllowed:true}"
                          (click)="removeArrayItem(i,reuseProp.promptRequests)">
                          <mat-icon>delete_outline</mat-icon>
                        </button>
                        <!-- <button mat-icon-button class="action-button" [matMenuTriggerFor]="menu" aria-label="Example
                          icon-button with a menu">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                          <button mat-menu-item (click)="openDialog(o,true)">
                            <mat-icon>edit</mat-icon>
                            <span>
                              {{'questions.typeOfQuestions.DragAndDrop.addOptions.toolTip.edit' | translate}}
                            </span>
                          </button>
                          <button mat-menu-item [disabled]="roleSer.accessData? !roleSer.accessData.deleteAllowed:true"
                            (click)="removeArrayItem(i,reuseProp.promptRequests)">
                            <mat-icon>delete_outline</mat-icon>
                            <span>
                              {{'questions.typeOfQuestions.DragAndDrop.addOptions.toolTip.delete' | translate}}
                            </span>
                          </button>
                        </mat-menu> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="filter-section">
        <div class="body-section title">
          <span>{{'questions.typeOfQuestions.DragAndDrop.labelResp' | translate}}</span>
        </div>
      </div>
      <div class="body-section-2">
        <ckeditor #myEditor3 [formControlName]="reuseProp.tempResponse" [editor]="Editor" (ready)="onReadyResponse($event)"></ckeditor>
        <div *ngIf="errorMessageResponse" class="alert alert-danger">{{ errorMessageResponse }}</div>
        <!-- <ckeditor data="Enter here..." [formControlName]="reuseProp.tempResponse" [config]="ckeditorConfig"></ckeditor> -->
      </div>
      <div class="btn-container">
        <button mat-flat-button color="" class="btn-warn" (click)='validateAndAddResponse()'>{{'questions.typeOfQuestions.DragAndDrop.btnResponse' | translate}}</button>
      </div>

      <div class="filter-section">
        <div class="body-section title">
          <span>{{'questions.typeOfQuestions.DragAndDrop.labelResponseText' | translate}}</span>
        </div>
      </div>
      <div class="body-section-2">
        <div class="score-wrapper">
          <div class="add-option">
            <div class="input-class-container">
              <div class="metrix-list-wrapper alphabetic-list col-12">
                <table class="container col-md-11
                  table-body" *ngFor="let o of
                  this.matchOrderForm.controls[reuseProp.responsesRequests].value;
                  let i= index">
                  <tbody>
                    <tr class="border-row" *ngIf="o?.responsedescription!==null">
                      <td scope="row" class="promt-item"><ng-component
                          [innerHTML]="o?.responsedescription.description | sanitizeHtml"></ng-component></td>
                      <td class="promt-btn">
                        <button mat-icon-button matTooltip="{{'questions.typeOfQuestions.DragAndDrop.addOptions.toolTip.edit' | translate}}"
                         (click)="openDialog(o,false)">
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button matTooltip="{{'questions.typeOfQuestions.DragAndDrop.addOptions.toolTip.delete' | translate}}"
                         [ngClass]="{'disableIcon': roleSer.accessData? !roleSer.accessData.deleteAllowed:true}"
                         (click)="removeArrayItem(i,reuseProp.responsesRequests)">
                          <mat-icon>delete_outline</mat-icon>
                        </button>
                        <!-- <button mat-icon-button class="action-button" [matMenuTriggerFor]="menu" aria-label="Example
                          icon-button with a menu">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                          <button mat-menu-item (click)="openDialog(o,false)">
                            <mat-icon>edit</mat-icon>
                            <span>
                              {{'questions.typeOfQuestions.DragAndDrop.addOptions.toolTip.edit' | translate}}
                            </span>
                          </button>
                          <button mat-menu-item [disabled]="roleSer.accessData? !roleSer.accessData.deleteAllowed:true" (click)="removeArrayItem(i,
                            reuseProp.responsesRequests)">
                            <mat-icon>delete_outline</mat-icon>
                            <span>
                              {{'questions.typeOfQuestions.DragAndDrop.addOptions.toolTip.delete' | translate}}
                            </span>
                          </button>
                        </mat-menu> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <ng-container *ngIf="isQuestionAdded">
      <section>
        <div class="container-fuild">
          <div class="matchOrderQuestion">
            <label class="Questions-score">{{'questions.typeOfQuestions.DragAndDrop.labelQuestScore' | translate}}</label>
            <div class=" abc">
              <input type="number" min="0" class="scoreReport form-control ng-pristine
                ng-valid
                ng-touched" [formControlName]="reuseProp.correctPoints" readonly>
            </div>
          </div>
          <br>
          <div class="w-100">

            <div class="score-rate col-12 ng-star-inserted">
              <h4 class="score col-1">{{'questions.typeOfQuestions.DragAndDrop.labelScore' | translate}}</h4>
              <h4 class="question-type-span score col-11"><ng-component
                  [innerHtml]="this.matchOrderForm.controls[reuseProp.questiondescription].value[reuseProp.description] | sanitizeHtml"></ng-component>
              </h4>
            </div>
            <div class="col-12" id="source" cdkDropList (cdkDropListDropped)="dropMain($event)" cdkDropListConnectedTo="builder">
              <div class="drop-list col-12" *ngFor="let o of matchOrderForm.controls[this.reuseProp.promptRequests].value; let i= index">
                <div class="score col-1">
                  <input type="number" min="0" max="9999.99" step=".01" [(ngModel)]="o.correctpoints" [ngModelOptions]="{standalone: true}"
                  (change)="o.correctpoints=promtPoint.value;calculateScore();" #promtPoint class="scoreReport"
                  (input)="validateInput($event, o, 'options')" (keypress)="omit_special_char($event)">
                </div>
                <div class="drop-list score col-11">
                  <div class="question-box" [innerHTML]="o?.promptdescription.description | sanitizeHtml"></div>
                  <div class="mid-line-box">
                    <div class="mid-line"></div>
                  </div>
                  <div class="answer-box">
                    <ul class="question-box-doted w-100 w-auto m-0 p-0">
                      <li class=" w-100 h-auto" cdkDrag [cdkDragData]="o" [innerHTML]="o.resValue | sanitizeHtml">
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- <div class="question-type-span question-type-paragraph score col-11">
                  <div class="question-span">

                    <span class="span w-25 w-auto h-auto" [innerHTML]="o?.promptdescription.description | sanitizeHtml"></span>

                    <hr class="line w-50 w-auto m-0">

                    <div class="w-25">
                      <ul class="question-box-doted w-100 w-auto m-0 p-0">
                        <li class="span-doted-box w-100 h-auto" cdkDrag [cdkDragData]="o" [innerHTML]="o.resValue | sanitizeHtml">
                        </li>
                      </ul>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>

          <div class="response-wrapper">
            <div class="drag-list" id="builder" cdkDropList [cdkDropListData]="matchOrderForm.controls[reuseProp.responsesRequests].value"
              cdkDropListConnectedTo="source" *ngFor="let o of promtNewArray; let i= index">
              <div class="drag-item">
                <button class="button" [cdkDragData]="o" [innerHTML]="o.resValue | sanitizeHtml" cdkDrag></button>
              </div>


            </div>
          </div>

          <!-- <div class="response-wrapper">
            <div class="drag-item" id="builder" cdkDropList [cdkDropListData]="matchOrderForm.controls[reuseProp.responsesRequests].value"
              cdkDropListConnectedTo="source" *ngFor="let o of promtNewArray; let i= index">
              <button class="button" [cdkDragData]="o" [innerHTML]="o.resValue | sanitizeHtml" cdkDrag></button>
            </div>
          </div> -->
        </div>
      </section>
    </ng-container>

    <div class="exp-panel ">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{'questions.typeOfQuestions.DragAndDrop.accordian.title' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="container-fluid body-section-2">
            <div class="row">
              <div class="col-md-2">
                <div class="scoring-check">
                  <mat-checkbox name="autoscoring" formControlName="autoScoring" [disabled]="true"><b>{{'questions.typeOfQuestions.DragAndDrop.accordian.checkbox' | translate}}</b> </mat-checkbox>
                  <!-- <div  class="invalid-feedback">
                                <div>Field is required</div>
                              </div> -->
                </div>
              </div>
              <br>
              <br>

              <div class="col-md-2">
                <div class="scoring-check">
                  <div class="invalid-feedback">
                    <!-- <div>Field is required</div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <div class="form-label">
                  <label>{{'questions.typeOfQuestions.DragAndDrop.accordian.selectOptions.option1.label' | translate}}</label>
                </div>
              </div>
              <div class="scoring-type-w">
                <mat-form-field class="scoring-type " appearance="fill" style="margin-left:19px">

                  <mat-select formControlName="scoringTypeExactMatch">
                    <mat-option [value]="option.id == 1 ? 'true' : 'false'" *ngFor="let option of QuestionScoringType">{{option.title}}</mat-option>
                  </mat-select>
                  <div class="invalid-feedback">
                    <!-- <div>Field is required</div> -->
                  </div>
                </mat-form-field>
              </div>
            </div>
            <div class="row items-center">
              <!-- <div class="col-md-2">
                <label class="form-label score-labels">{{'questions.typeOfQuestions.DragAndDrop.accordian.selectOptions.option2' | translate}}</label>
              </div>
              <div class="col-md-2 mrg-right">
                <input [formControlName]="reuseProp.penaltyPoints" class="form-control penalty-points" type="number" value="" min="0"
                  [attr.disabled]="true">

              </div>
              <div *ngIf="!matchOrderForm.get(reuseProp.penaltyPoints).valid &&
                matchOrderForm.get(reuseProp.penaltyPoints).touched">
                Required and only zero or positive numbers allowed
              </div> -->
              <div class="col-md-2">
                <label class="form-label score-labels" required>{{'questions.typeOfQuestions.DragAndDrop.accordian.selectOptions.option3.label' | translate}}</label>
              </div>
              <div class="col-md-2">
                <!-- <input [formControlName]="reuseProp.minScoreIfAttempt" type="number" min="0" max="9999" class="form-control
                  penalty-points" onkeypress="if(this.value.length == 4 ) return false;"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"> -->

                  <input type="number" class="form-control penalty-points" [formControlName]="reuseProp.minScoreIfAttempt" min="0" max="9999.99" step=".01"
                  (input)="validateInput($event, matchOrderForm.get(reuseProp.minScoreIfAttempt).value, 'minimumScore')" (keypress)="omit_special_char($event)">

                  <div *ngIf="!matchOrderForm.get(reuseProp.minScoreIfAttempt).valid
                    && (matchOrderForm.get(reuseProp.minScoreIfAttempt).touched || matchOrderForm.get(reuseProp.minScoreIfAttempt).dirty)" class="alert alert-danger zero">
                    {{'questions.typeOfQuestions.DragAndDrop.accordian.selectOptions.option3.errorMsg1' | translate}}
                  </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </form>
</div>
<div *ngIf="display">
  <app-choose-question-type></app-choose-question-type>
</div>

<div *ngIf="isListMode">
  <app-question-list></app-question-list>
</div>
